import { render, staticRenderFns } from "./CarouselItems.vue?vue&type=template&id=777f4f76"
import script from "./CarouselItems.vue?vue&type=script&lang=js"
export * from "./CarouselItems.vue?vue&type=script&lang=js"
import style0 from "./CarouselItems.vue?vue&type=style&index=0&id=777f4f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports